<template>
	<div class="list-item list-item-multi-row">
		<div class="column">
			<div class="row separated">
				<label class="field inline row">
					<span class="label rigid centered">{{label}}</span>
				</label>
				<span class="gap">
					<slot name="error-inline"></slot>
					<slot name="success-inline"></slot>
					<slot name="updating-inline"></slot>
				</span>
				<footer class="row rigid">
					<toggle-switch v-model="inputValue" :unchecked-text="'Off'" :checked-text="'On'" @change="onChange" :disabled="!canEdit" class="rigid centered"></toggle-switch>
				</footer>
			</div>

			<div v-if="inputValue" class="row separated">
				<slot name="field-assist"></slot>
			</div>

		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import ToggleSwitch from './ToggleSwitch.vue';
import Collapsible from './Collapsible.vue';
export default {
	name: 'SettingToggle',
	data() {
		return {
			inputValue: this.model,
			changed: false,
			dirty: false
		};
	},
	props: ['label', 'model', 'canEdit'],
	components: {
		ToggleSwitch,
		Collapsible
	},
	methods: {
		onChange(val) {

			// deactivate other components
			this.$root.$emit('active', this._uid);

			this.$emit('change', val);
			this.setValue(val);
		},
		setValue(val) {
			this.inputValue = val;
		}
	},
	watch:{
		model: {
			handler: 'setValue',
			immediate: true
		}
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

	.legend-footer .code {
		width: 100px;
	}

	.field-assist {
		position: relative;
		margin-bottom: 0;
		white-space: normal;
		max-width: 75ch;
	}

	.label {
		width: 100%;
	}

	@media only screen and (max-width : 600px) {
		.label {
			max-width: 300px;
		}
	}

	@media only screen and (max-width : 425px) {
		.label {
			max-width: 200px;
		}
	}

</style>



// WEBPACK FOOTER //
// ./src/components/SettingToggle.vue